export default "./dist/stdassets/images/icons/globe_add.png";